import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService, QueryParameter } from 'yt-ng-framework';
import { TrosakDokument } from './trosak-dokument';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-trosak-dokument-tab-update',
  templateUrl: './trosak-dokument-tab-update.component.html'
})
export class TrosakDokumentTabUpdateComponent extends BaseTabsUpdateComponent<TrosakDokument> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<TrosakDokument>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.defaultUpdateButtons.ButtonsConfig.SaveButtonConfig.Visible = false;
    this.defaultUpdateButtons.ButtonsConfig.ResetButtonConfig.Visible = false;
    
    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.ItemSaved
    .subscribe((value)=>{
      if (value){
        let idParameter = [new QueryParameter("id", this.baseUpdateComponent.Item.ID)];
        this.baseDataService.Get(this.baseUpdateComponent.modelData.MainList.ModelName,
            "GetViewItemByID",
            idParameter,
            this.baseUpdateComponent.modelData.MainList.ShortModelClass)
            .subscribe((data:any)=>{
            // ovo utiče na osvežavanje tabele za dokumenta na pregledu. Osvežava MainItems
            this.tabsContainerService.EmitItem(data);
            })
      }
    })
  }

  

}
